import { FC, useContext, useMemo, useState, useEffect } from 'react'
import { useIntl } from 'react-intl'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { PageTitle } from '../../../_metronic/layout/core'
import DeviceListAdmin from '../../modules/ems/components/DeviceAdminList/List/DeviceList.controller'
import DeviceListController from '../../../_metronic/partials/widgets/tables/List/DeviceList.controller'
import { AuthContext } from '../../context/auth/auth.context'
import { CardsWidgetOffline } from './card/CardsWidgetOffline'
import { MixedWidget7 } from './card/MixedWidget7'
import { ChartsWidget1 } from './card/ChartsWidget1'
import SpeedGaugeCard from './card/SpeedGaugeCard'
import { TablesWidget9 } from './card/TablesWidget9'
import { HttpService } from '../../services/http.services'
import EquipmentLatestDataController from './card/EquipmentLatestDataTable/EquipmentLatestData.controller'
import { MixedWidget1, MixedWidget10, MixedWidget11, MixedWidget13, MixedWidget14, MixedWidget15, MixedWidget2, MixedWidget3, MixedWidget4, MixedWidget5, MixedWidget6, MixedWidget8, MixedWidget9 } from '../../../_metronic/partials/widgets'
import { NotificationCard } from './card/NotificationCard'
import { StatusCountCard } from './card/StatusCountCard'
import { MixedWidget7c } from '../../../_metronic/partials/widgets/_new/cards/MixedWidget7'
import { NotificationBarChart } from './card/NotificationBarChart'
import { AssistanceCard } from './card/AssistanceCard'

interface DeviceStatus {
  totalDevices: number
  activeDevices: number
  inactiveDevices: number
  onlineDevices: number
  offlineDevices: number
  notificationDevices: number
}

const DashboardPage: FC = () => {
  const { userId } = useContext(AuthContext)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  // Memoize the admin device list to prevent unnecessary re-renders
  const adminDeviceList = useMemo(() => {
    return userId === 1 || userId === 45 ? (
      <div className="col-xxl-12">
        <DeviceListAdmin />
      </div>
    ) : null
  }, [userId])


  return (
    <>
      <div className='row g-5 g-xl-10 mb-5 mb-xl-10'>
        <div className='col-xxl-6'>
          <div className='row mb-5'>
              <div className='col-md-12'>
                <StatusCountCard
                    className='card-xl-stretch mb-xl-8'
                    chartHeight='250px'
                  />
              </div>
          </div>
          <div className='row'>
              <div className='col-md-12'>
                  <NotificationBarChart
                  className='card-xl-stretch mb-xl-8'
                  chartColor='danger'
                  chartHeight='200px'
                  />
              </div>
          </div>
        </div>
        <div className='col-xxl-6'>
          <NotificationCard className='' /> 
        </div>
      </div>
      <div className='row g-5 g-xl-10 mb-5 mb-xl-10'>
        <div className="col-xxl-12">
          <EquipmentLatestDataController />
        </div>
      </div>
      {/* Fifth Row */}
      <div className='row g-5 g-xl-10 mb-5 mb-xl-10'>
        <div className="col-xxl-12">
          {/* <DeviceListController /> */}
        </div>
      </div>

      {/* Conditional Admin Row */}
      <div className='row g-5 g-xl-10 mb-5 mb-xl-10'>
        {adminDeviceList}
      </div>
    </>
  )
}

const DashboardWrapper: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.DASHBOARD' })}</PageTitle>
      <DashboardPage />
    </>
  )
}

export { DashboardWrapper }